export const CHANGE_THEME_TYPE = '@@ui/theme/CHANGE_THEME_TYPE';

export function changeThemeType() {
  return {
    type: CHANGE_THEME_TYPE
  };
}
